module.exports = __webpack_public_path__ + "static/media/twitter-link.bcdb12d1.svg";